import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ConciliacaoService } from '../../../services/conciliacao.service';
import { ModoBuscaDataLancamentoEnum } from '../../../models/enum/modo-busca-data-lancamento-enum';
import { OrigemLancamento } from '../../../../../../shared/models/enums/origem-lancamento';
import { BancoOrigemEnumNome } from '../../../../../../shared/models/enums/banco-origem-enum';

export interface FiltroDialogData {
  modoBuscaEmMassa: boolean;
}

@Component({
  selector: 'app-filtro-dialog',
  standalone: false,
  templateUrl: './filtro-dialog.component.html',
  styleUrl: './filtro-dialog.component.scss'
})
export class FiltroDialogComponent implements OnInit {

  readonly modoBuscaEmMassa: boolean;
  readonly titulo: string;
  readonly textoBotaoAplicar: string;

  // Mesmo padrão do toggle "buscarEm" do card-busca
  origemBanco = OrigemLancamento.Banco;
  origemCaixa = OrigemLancamento.Caixa;
  get tipoBancoNome(): string { return BancoOrigemEnumNome.get(this.conciliacaoService.tipoBanco) as string; }

  origemBuscaEmMassa: OrigemLancamento;
  modoBusca: ModoBuscaDataLancamentoEnum = ModoBuscaDataLancamentoEnum.DIA_UNICO;
  buscarSubtabelas: boolean;
  dataInicioBusca: Date;
  dataFimBusca: Date;
  profundidadeBusca: number;
  tempoLimiteBusca: number;

  opcoesModoBusca = [
    { label: 'Buscar em um único dia', value:  ModoBuscaDataLancamentoEnum.DIA_UNICO },
    { label: 'Buscar por intervalo', value:  ModoBuscaDataLancamentoEnum.INTERVALO },
    { label: 'Buscar no dia do lançamento', value: ModoBuscaDataLancamentoEnum.DIA_LANCAMENTO }
  ];

  // Na busca em massa a partir do banco, "buscarSubtabelas" também decide se cada
  // lançamento base (filho) é processado individualmente em vez do grupo inteiro pelo pai — a
  // label reflete esse efeito aqui; fora desse caso mantém o significado original (candidatos de
  // busca no lado oposto).
  get labelBuscarSubtabelas(): string {
    return this.modoBuscaEmMassa && this.origemBuscaEmMassa === this.origemBanco
      ? 'Buscar a partir de lançamentos base'
      : 'Buscar dentro de lançamentos agrupados';
  }

  isDisabledDataInicio(): boolean {
    return this.modoBusca === ModoBuscaDataLancamentoEnum.DIA_LANCAMENTO;
  }
  
  isDisabledDataFim(): boolean {
    return this.modoBusca !== ModoBuscaDataLancamentoEnum.INTERVALO;
  }

  constructor(
    private conciliacaoService: ConciliacaoService,
    @Optional() @Inject(MAT_DIALOG_DATA) data: FiltroDialogData | null,
  ) {
    this.modoBuscaEmMassa = data?.modoBuscaEmMassa ?? false;
    this.titulo = this.modoBuscaEmMassa ? 'Busca em massa' : 'Filtros';
    this.textoBotaoAplicar = this.modoBuscaEmMassa ? 'Buscar em Massa' : 'Aplicar';
  }

  ngOnInit(): void {
    this.origemBuscaEmMassa = this.conciliacaoService.origemBuscaEmMassa;
    this.buscarSubtabelas = this.conciliacaoService.buscarSubtabelas;
    this.modoBusca = this.conciliacaoService.modoBusca;
    this.dataInicioBusca = this.conciliacaoService.dataInicioBusca;
    this.dataFimBusca = this.conciliacaoService.dataFimBusca;
    this.profundidadeBusca = this.conciliacaoService.profundidadeBusca;
    this.tempoLimiteBusca = this.conciliacaoService.tempoLimiteBusca;
  }

  public aplicarClick(): void {
    this.conciliacaoService.origemBuscaEmMassa = this.origemBuscaEmMassa;
    this.conciliacaoService.buscarSubtabelas = this.buscarSubtabelas;
    this.conciliacaoService.modoBusca = this.modoBusca;
    this.conciliacaoService.dataInicioBusca = this.dataInicioBusca;
    if (this.modoBusca === ModoBuscaDataLancamentoEnum.DIA_UNICO)
      this.conciliacaoService.dataFimBusca = this.dataInicioBusca;
    else
      this.conciliacaoService.dataFimBusca = this.dataFimBusca;
    this.conciliacaoService.profundidadeBusca = this.profundidadeBusca;
    this.conciliacaoService.tempoLimiteBusca = this.tempoLimiteBusca;
  }

  public onModoBuscaChange(valor: ModoBuscaDataLancamentoEnum | null) {
    setTimeout(() => {
      if (!valor) {
        this.modoBusca = ModoBuscaDataLancamentoEnum.INTERVALO;
        return;
      }
  
      this.modoBusca = valor;
    }, 1);
  }
}
